import Api from 'App/api'

export const getInspectionsWithSettings = Api.get({
  controller: 'inspections',
  action: 'listWithSettings',
})

export const getInspection = Api.get({
  controller: 'inspections',
  action: 'getInspection',
})

export const saveInspection = Api.post({
  controller: 'inspections',
  action: 'save',
})

export const uploadAttachments = Api.postMultipart({
  controller: 'inspections',
  action: 'uploadAttachments',
})

export const getInspectionAttachmentUrl = payload =>
  Api.getUrl(
    { controller: 'inspections', action: 'viewAttachment' },
    { ...payload },
  )
